import { render, staticRenderFns } from "./hotel-mask.vue?vue&type=template&id=24205712&scoped=true&"
import script from "./hotel-mask.vue?vue&type=script&lang=js&"
export * from "./hotel-mask.vue?vue&type=script&lang=js&"
import style0 from "./hotel-mask.vue?vue&type=style&index=0&id=24205712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24205712",
  null
  
)

export default component.exports